import { VirtualArtGalleryComponent } from './virtual-art-gallery/virtual-art-gallery.component';
import { VirtualGalleryDemoComponent } from './virtual-gallery-demo/virtual-gallery-demo.component';

export const routes = [
    { path: 'vag', component: VirtualArtGalleryComponent},
    { path: 'vag-demo', component: VirtualGalleryDemoComponent}
];